import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { FilterOptionsStyled } from '@/components/ListFilter/FilterOptionsStyled'
import { FilterActions, useFiltersContext } from '@/context/filters'

export const LengthOfStayFilter = () => {
  const [{ reservationMinLengthOfStay }, FilterDispatch] = useFiltersContext()

  const [dropdownExpanded, setDropdownExpanded] = useState(false)

  const options = [
    { val: 45, label: '45+' },
    { val: 90, label: '90+' },
    { val: 180, label: '180+' },
    { val: 365, label: '365+' },
  ]

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: number | undefined) => {
    setDropdownExpanded(false)
    FilterDispatch(FilterActions.setReservationMinLengthOfStay({ val }))
  }

  return (
    <Dropdown
      className="mr-4 hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle="Length of Stay"
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!reservationMinLengthOfStay}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <ul>
          <li
            className={`${!reservationMinLengthOfStay ? 'selected' : ''}`}
            onClick={() => changeFilter(undefined)}
            role={'presentation'}
          >
            All
          </li>
          {options.map((val, i) => (
            <li
              className={`${val.val === reservationMinLengthOfStay ? 'selected' : ''}`}
              key={i}
              onClick={() => changeFilter(val.val)}
              role={'presentation'}
            >
              {val.label}
            </li>
          ))}
        </ul>
      </FilterOptionsStyled>
    </Dropdown>
  )
}
